const finiteNumber = (value, fallback = 0) => {
    const number = Number(value)
    return Number.isFinite(number) ? number : fallback
}

export const CONNECTION_VALUE_SOURCES = ['own', 'from', 'to']

export function normalizeConnectionValueSource(value) {
    return CONNECTION_VALUE_SOURCES.includes(value) ? value : 'own'
}

export function getConnectionEndpointBadge(connection, role) {
    let page = connection?.parent
    while (page && page.obj !== 'page' && page.obj !== 'template_page') page = page.parent
    const id = role === 'to' ? connection?.to : connection?.from
    return page?.findOne?.(`#${id}`) ?? page?.find?.(node => node.obj === 'badge' && node.id?.() === id)?.[0] ?? null
}

export function getEffectiveConnectionValue(connection) {
    const source = normalizeConnectionValueSource(connection?.value_source)
    if (source === 'from' || source === 'to') {
        return finiteNumber(getConnectionEndpointBadge(connection, source)?.value)
    }
    return finiteNumber(connection?.value)
}

export function connectionFlowInput(connection) {
    return { ...connection, value: getEffectiveConnectionValue(connection) }
}
